export const generateId = (s = ''): string => {
  return `${s.toLocaleLowerCase().replace(/ /g, '-')}-${Date.now()}`;
}
